import React from 'react'
import { Link } from 'react-router-dom'
import { IoIosArrowBack } from 'react-icons/io'
import { FilledInput, FormControl, InputAdornment, InputLabel, TextField, Select, MenuItem, TextareaAutosize } from '@mui/material'


const Feedback = () => {
  const [feedback, setFeedback] = React.useState('');

  const handleChange = (event) => {
    setFeedback(event.target.value);
  };
  const Dinein = 'Dine In';
  const takeaway = 'Take Away';
  const delivery = 'Delivery';
  const pickup = 'Pickup';
  const drivethru = 'Drive Thru';

  return (
    <div className="min-h-[100vh] md:container md:mx-auto flex-auto">
      <div className='flex justify-start'>
        <div className='flex rounded-md mt-[3vh] p-2 flex-wrap'>
          <Link to={"/menu"}>
            <span className='h-7 w-7 rounded-full border-light-secondary border-2 bg-gray-100 flex items-center justify-center font-bold cursor-pointer hover:bg-light-secondary text-light-secondary hover:text-white' >
              <IoIosArrowBack className='font-bold' size={20} /></span>
          </Link>
        </div>
      </div>
      <div className="flex items-center justify-center">
        <div className="text-center ">
          <h1 className="text-4xl font-bold mb-4">Have Some Feedback To Share?</h1>
          <p><span className="font-bold text-red-500">Well, you’ve come to the right place!</span></p>
          <p>Fill in the sections below, and we'll be in touch soon. If you want</p>
          <p>to contact a specific store, visit our locations page for store contact</p>
          <p>details.* indicates a required answer</p>
        </div>
      </div>
      <div className="flex flex-wrap flex-col lg:flex-row">
        <div className="flex-1 bg-white m-3 p-3 w-[90%] lg:w-[50%]">
          <h1 className="text-2xl font-bold mb-4">Contact Details</h1>
          <div>
            <TextField
              id="filled-multiline-flexible"
              className="mb-4 w-[50%]" style={{ padding: '8px' }}
              label="Full Name *"
              multiline
              maxRows={4}
              halfWidth
              variant="filled"
            />
            <FormControl halfWidth variant="filled" className="mb-4 w-[50%]" style={{ padding: '8px' }}>
              <InputLabel htmlFor="filled-adornment-amount">Phone Number (3XXXXXXXXX)*</InputLabel>
              <FilledInput
                id="filled-adornment-amount"
                startAdornment={<InputAdornment position="start">
                  <span className="font-bold"><b>+92 |</b></span>
                </InputAdornment>}
              />
            </FormControl>
            <TextField
              id="filled-multiline-flexible"
              className="mb-4 " style={{ padding: '8px' }}
              label="Email *"
              multiline
              maxRows={4}
              fullWidth
              variant="filled"
            />
            <TextField
              id="filled-multiline-flexible"
              className="mb-4 " style={{ padding: '8px' }}
              label="Order ID *"
              multiline
              maxRows={4}
              fullWidth
              variant="filled"
            />
            <FormControl variant="filled" sx={{ my: 1 }} fullWidth>
              <InputLabel id="demo-simple-select-filled-label">FeedBack Channel*</InputLabel>
              <Select
                labelId="demo-simple-select-filled-label"
                id="demo-simple-select-filled"
                value={feedback}
                onChange={handleChange}
              >
                <MenuItem value={Dinein}>Dine In</MenuItem>
                <MenuItem value={takeaway}>Take Away</MenuItem>
                <MenuItem value={delivery}>Delivery</MenuItem>
                <MenuItem value={pickup}>Pickup</MenuItem>
                <MenuItem value={drivethru}>Drive Thru</MenuItem>
              </Select>
            </FormControl>
          </div>
        </div>
        <div className="flex-1 bg-white m-3 p-3 w-[90%] lg:w-[50%]">
          <h1 className="text-2xl font-bold mb-4">About Your Visit</h1>
          <div>
            <FormControl variant="filled" sx={{ my: 1, minWidth: 360 }}>
              <InputLabel id="demo-simple-select-filled-label">Select Store*</InputLabel>
              <Select
                labelId="demo-simple-select-filled-label"
                id="demo-simple-select-filled"
                value={feedback}
                onChange={handleChange}
              >
                <MenuItem value={Dinein}>Faisalabad</MenuItem>
                <MenuItem value={takeaway}>Karachi</MenuItem>
                <MenuItem value={delivery}>Lahore</MenuItem>
                <MenuItem value={pickup}>Multan</MenuItem>
                <MenuItem value={drivethru}>Sailkot</MenuItem>
              </Select>
            </FormControl>
            <TextField
              id="filled-multiline-flexible"
              className="mb-4"
              label="Date *"
              multiline
              maxRows={4}
              halfWidth
              variant="filled"
              type='date'
            />
            <FormControl variant="filled" sx={{ my: 1 }} fullWidth>
              <InputLabel id="demo-simple-select-filled-label">Feed Back Type*</InputLabel>
              <Select
                labelId="demo-simple-select-filled-label"
                id="demo-simple-select-filled"
                value={feedback}
                onChange={handleChange}
              >
                <MenuItem value={Dinein}>Comments</MenuItem>
                <MenuItem value={takeaway}>Suggestions</MenuItem>
                <MenuItem value={delivery}>Questions</MenuItem>
              </Select>
            </FormControl>
            <TextareaAutosize
              placeholder="Feedback Message"
              minRows={5}
              className="mb-4 w-full focus:ring-red-200 bg-gray-100"
            />
          </div>
        </div>
      </div>
      {/* <button className="bg-red-600 text-white w-1/5 mx-auto p-4 items-center justify-center">Submit</button> */}
      <div className='flex items-center justify-center'>
        <button className="bg-red-600 text-white w-1/5 h-1/5 mx-auto my-auto p-4 items-center justify-center">Submit</button>
      </div>
    </div>
  )
}

export default Feedback;